export const setTitle = title =>
   (document.title = document.title !== title ? title : document.title);



// WEBPACK FOOTER //
// ./src/utils/title.js